import { createSlice, current } from '@reduxjs/toolkit'

const companyList = createSlice({
    name: 'companyList',//Данные по компаниям
    initialState: {
        list: [],
        listArchiveLoaded: false, //Флаг загрузки архива
        listInRequest: null, //Список входящих заявок 
        listOutRequest: null, //Список исходящих заявок 
        changed: false, //Делаем true при изменении компании. Тогда появляется модальное окно с требованием обновить страницу
        changedThis: false //Флаг указывает на то что изменение компании происходит в этом окне. Тогда не будет выводится модальное окно с требованием обновить страницу
    },
    reducers: {
        load(state, action) {
            const company = action.payload.company.map(item => {
                return {
                    ...item, External: false
                };
            });
            const companyExternal = action.payload.companyExternal.map(item => {
                return {
                    ...item, External: true
                };
            });

            state.list = [...company, ...companyExternal].sort((a, b) => a.Name - b.Name);
        },
        loadArchive(state, action) {
            const company = action.payload.company.map(item => {
                return {
                    ...item, External: false
                };
            });

            state.list = [...state.list.filter(a => a.ID_Status === 1), ...company];
            state.listArchiveLoaded = true;
        },
        update(state, action) {
            const model = action.payload.model;

            /*const list_new = current(state.list).map(item => {
                if (item.ID === model.ID) {
                    return { ...item, Name: model.Name, ID_Status: model.ID_Status }
                }
                else {
                    return item;
                }
            })

            state.list = list_new;*/
            state.list = [...state.list.filter(a => a.ID !== model.ID), model];
        },
        updateExternal(state, action) {
            const list = action.payload.data;
            state.list = [...state.list.filter(a => a.External === false), ...list];
        },
        remove(state, action) {
            const id_company = action.payload.id_company;
            state.list = state.list.filter(a => a.ID !== id_company);
        },
        loadListInRequest(state, action) {
            state.listInRequest = action.payload.data;
        },
        loadListOutRequest(state, action) {
            state.listOutRequest = action.payload.data;
        },
        changed(state, action) {
            state.changed = true;
        },
        changedThis(state, action) {
            state.changedThis = true;
        },
    }
})

export const { load, loadArchive, remove, update, updateExternal, loadListInRequest, loadListOutRequest, changed, changedThis } = companyList.actions
export default companyList.reducer